const PAGE_INSTRUCTIONS_UPDATED = 'PAGE_INSTRUCTIONS_UPDATED';
const NEW_INSTRUCTIONS_UPDATED = 'NEW_INSTRUCTIONS_UPDATED';
const MORE_INSTRUCTIONS_UPDATED = 'MORE_INSTRUCTIONS_UPDATED';

export const dispatchUpdatedPageInstructions = (payload) => ({
  type: PAGE_INSTRUCTIONS_UPDATED,
  payload,
});

export const dispatchNewInstructions = (payload) => ({
  type: NEW_INSTRUCTIONS_UPDATED,
  payload,
});

export const dispatchMoreInstructions = (payload) => ({
  type: MORE_INSTRUCTIONS_UPDATED,
  payload,
});
